import { render } from "./BikeOverviewVideo.vue?vue&type=template&id=1cd70b4e&scoped=true"
import script from "./BikeOverviewVideo.vue?vue&type=script&lang=js"
export * from "./BikeOverviewVideo.vue?vue&type=script&lang=js"

import "./BikeOverviewVideo.vue?vue&type=style&index=0&id=1cd70b4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd70b4e"]])

export default __exports__